module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/awesome-typescript-loader/dist/entry.js!./post.ts"));
	}, "blog-async-post");
}